module.exports = __webpack_public_path__ + "static/media/manos-corazon.0e85be0a.webp";